export const isTestEnvironment = (): boolean => import.meta.env.DEV && import.meta.env.VITE_ENABLE_TEST_AUTH === 'true'
